angular
  .module('pb.core.user')

  .directive('pbCanDelete', [
    'LoggedUser',

    function(LoggedUser) {
      return {
        restrict: 'A',
        priority: 997,
        link: function(scope, element, attrs) {
          var resourceType = attrs.pbCanDelete,
            resources = LoggedUser.get().getResources();

          if (!resourceType) {
            return;
          }

          if (
            typeof resources !== 'object' ||
            !resources[resourceType] ||
            !angular.isArray(resources[resourceType])
          ) {
            element.remove();
            return;
          }

          if (resources[resourceType].indexOf('delete') >= 0) {
            //remove the attribute to avoid infinite loop
            element.removeAttr('pb-can-delete');
          } else {
            element.remove();
          }
        }
      };
    }
  ]);
